import { ThemeConfig, extendTheme } from '@chakra-ui/react';
import components from './components';

export const brandColorPalette = ['#78A22F', '#FF9E00', '#904287', '#004A77', '#008F87', '#595959', '#E5F1D0', '#FFECCC', '#ECD6EA', '#B1E1FF'];

const semanticTokens = {
  colors: {
    green: {
      100: '#CBF5E5',
      800: '#176448'
    },
    gray: {
      100: '#F6F8FA',
      800: '#525866'
    },
    blue: {
      100: '#C2EFFF',
      800: '#164564'
    },
    purple: {
      100: '#CAC2FF',
      800: '#2B1664'
    },
    red: {
      500: '#DF1C41'
    },
    bg: {
      overlay: 'rgba(2, 13, 23, 0.19)',
      body: '#F8F8F8',
      avatar: '#E2E4E9',
      navigator: 'white',
      button: {
        primary: '#61A318',
        disabled: '#F6F8FA'
      },
      navigatorItem: {
        hover: '#F6F8FA',
        active: '#61A318'
      }
    },
    text: {
      body: '#525866',
      navigatorItem: {
        active: '#0A0D14'
      },
      heading: '#0A0D14',
      input: '#0E121B',
      placeholder: '#868C98',
      button: {
        disabled: '#CDD0D5'
      }
    },
    border: {
      button: {
        outline: '#E2E4E9',
        disabled: '#F6F8FA'
      },
      input: {
        outline: '#E2E4E9'
      }
    }
  },
  shadows: {
    button: '0px 1px 2px 0px rgba(82, 88, 102, 0.06)',
  }
}

const styles = {
  global: {
    html: {
      overflowX: 'hidden',
    },
    body: {
      fontFamily: 'Inter',
      fontWeight: 400,
      color: 'text.body',
      fontSize: '14px',
      lineHeight: '142.857%',
      letterSpacing: '-0.084px',
      backgroundColor: 'bg.body',
      overflowX: 'hidden',
      fontStyle: 'normal'
    },
    '#root': {
      display: 'flex',
      flexDir: 'column'
    },
    '.scroll': {
      WebkitOverflowScrolling: 'touch',
      '&::-webkit-scrollbar': { 
        bgColor: 'transparent', 
        w: '6px',
        h: '6px' 
      },
      '&::-webkit-scrollbar-thumb': { 
        bgColor: 'rgba(217, 217, 217, 0.3)', 
        borderRadius: '20px', 
        transform: 'scaleX(0.3)', 
        w: '6px',
        h: '6px' 
      },
      '&::-webkit-scrollbar-track': { 
        backgroundClip: 'content-box', 
        bgColor: 'transparent' 
      }
    }
  }
};

const config: ThemeConfig = {
  useSystemColorMode: false,
  cssVarPrefix: 'patri'
};

export default extendTheme({
  config,
  semanticTokens,
  styles,
  components
});